import {Component, Inject} from '@angular/core';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {FlashCardInterface} from 'fuse-core/components/flashcard/flash-card.interface';

@Component({
    selector: 'app-voice-recording-modal',
    templateUrl: './voice-recording-modal.component.html',
    styleUrls: ['./voice-recording-modal.component.scss']
})
export class VoiceRecordingModalComponent {

    constructor(
        private matDialogRef: MatDialogRef<VoiceRecordingModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: FlashCardInterface
    ) {
    }

    public close(): void {
        this.matDialogRef.close();
    }
}
